import { ref, computed } from 'vue';
import { ButtonStyle } from '../../../../components/buttons/ButtonComponent/model.js';
import { usePortalStore } from '../../../../components/specific/portal/store/portal/index.js';
import { PortalRouteName } from '../model.js';

var ReloadRouteDataSource;
(function (ReloadRouteDataSource) {
    ReloadRouteDataSource["SHIFTS"] = "shifts";
    ReloadRouteDataSource["USERS"] = "users";
})(ReloadRouteDataSource || (ReloadRouteDataSource = {}));
const reloadFunctions = ref({
    [ReloadRouteDataSource.SHIFTS]: new Map(),
    [ReloadRouteDataSource.USERS]: new Map(),
});
const augmentReload = (key, newReload, dataSource) => {
    reloadFunctions.value[dataSource].set(key, newReload);
};
const executeReloads = (dataSource) => {
    reloadFunctions.value[dataSource].forEach((fn) => fn());
};
const shiftDetailsHeadingValues = (headingParams) => computed(() => {
    const portalStore = usePortalStore();
    // PARAMS & SHIFT
    const { params } = headingParams.route;
    const { shiftID } = params;
    const prevRouteName = headingParams.route.params
        .backRouteName;
    const shift = shiftID ? portalStore.shifts.get(shiftID) : null;
    const title = shift === null || shift === void 0 ? void 0 : shift.computed.detailsHeaderTitle;
    return {
        title,
        backLocation: {
            name: prevRouteName !== null && prevRouteName !== void 0 ? prevRouteName : PortalRouteName.JOBS,
        },
        backButtonStyle: ButtonStyle.FROSTED,
        ...(portalStore.viewAs.nurse ? {} : {
            confirmIcon: 'sync-alt',
            confirmIconActiveAnimation: 'rotate',
            confirmButtonStyle: ButtonStyle.FROSTED,
            confirmEvent: () => executeReloads(ReloadRouteDataSource.USERS),
        }),
        overflowVisible: true,
    };
    // Above type-cast is for vite/vue-tsc
});
const shiftsListHeadingValues = (_headingParams) => computed(() => ({
    title: 'Jobs',
    backButtonStyle: ButtonStyle.FROSTED,
    confirmIcon: 'sync-alt',
    confirmIconActiveAnimation: 'rotate',
    confirmButtonStyle: ButtonStyle.FROSTED,
    confirmEvent: () => executeReloads(ReloadRouteDataSource.SHIFTS),
    secondaryComponent: 'PortalMapViewToggle',
}));

export { ReloadRouteDataSource, augmentReload, executeReloads, shiftDetailsHeadingValues, shiftsListHeadingValues };
